var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"text-h5 font-weight-bold mb-2 text--primary"},[_vm._v("Sistema")]),_c(_setup.FormaPagamentoPadrao),_c(_setup.ClientePadrao),_c(_setup.BloquearTela)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }